import { all } from "redux-saga/effects";
import authSaga from "./authSaga";
import homeSaga from "./homeSaga";
import itemSaga from "./itemSaga";

function* rootSaga() {
  yield all([authSaga(), homeSaga(), itemSaga()]);
}
export default rootSaga;
